var _defs, _rect, _rect2, _rect3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(4.309082%, 5.879211%, 12.159729%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(100%, 100%, 100%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(4.309082%, 5.879211%, 12.159729%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(81.17981%, 42.349243%, 18.429565%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.517001, 62.265437)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 22.859375 -42.875 C 21.179688 -42.875 19.570312 -42.046875 18.03125 -40.390625 C 16.5 -38.734375 15.378906 -37.085938 14.671875 -35.453125 L 13.59375 -33 L 3.71875 -37.78125 C 3.84375 -38.195312 4.050781 -38.738281 4.34375 -39.40625 C 4.632812 -40.082031 5.328125 -41.289062 6.421875 -43.03125 C 7.515625 -44.78125 8.722656 -46.316406 10.046875 -47.640625 C 11.367188 -48.960938 13.171875 -50.164062 15.453125 -51.25 C 17.742188 -52.34375 20.210938 -52.890625 22.859375 -52.890625 C 26.253906 -52.890625 29.222656 -52.457031 31.765625 -51.59375 C 34.304688 -50.738281 36.269531 -49.671875 37.65625 -48.390625 C 39.039062 -47.109375 40.160156 -45.597656 41.015625 -43.859375 C 41.878906 -42.117188 42.425781 -40.535156 42.65625 -39.109375 C 42.882812 -37.679688 43 -36.1875 43 -34.625 C 43 -32.363281 42.367188 -29.984375 41.109375 -27.484375 C 39.859375 -24.984375 38.335938 -22.757812 36.546875 -20.8125 C 34.765625 -18.863281 32.972656 -17.078125 31.171875 -15.453125 C 29.367188 -13.835938 27.835938 -12.59375 26.578125 -11.71875 L 24.6875 -10.390625 L 43.953125 -10.390625 L 43.953125 0 L 3.46875 0 L 3.46875 -2.953125 C 4.175781 -3.546875 5.140625 -4.351562 6.359375 -5.375 C 7.578125 -6.40625 9.71875 -8.367188 12.78125 -11.265625 C 15.84375 -14.160156 18.550781 -16.878906 20.90625 -19.421875 C 23.257812 -21.960938 25.398438 -24.679688 27.328125 -27.578125 C 29.253906 -30.472656 30.21875 -32.820312 30.21875 -34.625 C 30.21875 -35.34375 30.144531 -36.054688 30 -36.765625 C 29.851562 -37.484375 29.570312 -38.351562 29.15625 -39.375 C 28.738281 -40.40625 27.984375 -41.242188 26.890625 -41.890625 C 25.796875 -42.546875 24.453125 -42.875 22.859375 -42.875 Z M 22.859375 -42.875 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.4c14a9a589a1a472f3e1c902f57a9450.svg";
export { ForwardRef as ReactComponent };